module.exports = __webpack_public_path__ + "img/feat3Icon.3de28fa5.png";